/**
 * Dashboard.jsx - Entry point per la dashboard
 * Usa DynamicDashboard che legge tutto da Blueprint
 */

import React from 'react';
import DashboardLayout from './DashboardLayout';
import DynamicDashboard from './DynamicDashboard';

const Dashboard = () => {
  return (
    <DashboardLayout>
      <DynamicDashboard />
    </DashboardLayout>
  );
};

export default Dashboard;
